<script>
    export let label;
    export let image;
</script>

<style>
    div.inner {
        height: 0;
        padding-top: 80%;
        background-size: fit;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }
</style>

<div><div class="inner" style="background-image: url({image})"/><p>{label}</p></div>